.Form.grid {
  display: grid;
  gap: var(--space-xl);

  /* minmax(0, 1fr) (not minmax(250px, 1fr)) lets the two tracks shrink with the
     container instead of forcing a 500px floor that overflows the page. */
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

/* Collapse the two-up form to a single column on phones so fields stay
   comfortably wide rather than cramped side by side. */
@media (--max-sm) {
  .Form.grid {
    grid-template-columns: 1fr;
  }
}

.Form.vertical {
  display: flex;
  flex-direction: column;
  gap: var(--space-xl);
}
